import type { Tour } from 'nextstepjs'

type Translate = (key: string) => string

export const PRODUCT_GALLERY_ONBOARDING_TOUR = 'product-gallery-onboarding'

export function buildProductGalleryOnboardingSteps(t: Translate): Tour[] {
  return [
    {
      tour: PRODUCT_GALLERY_ONBOARDING_TOUR,
      steps: [
        {
          title: t('products-page.onboarding.steps.product-list.title'),
          content: t('products-page.onboarding.steps.product-list.description'),
          selector: '#product-products-tab-products',
          side: 'bottom',
          pointerPadding: 1,
          pointerRadius: 8,
          disableInteraction: true,
          scrollOffset: 24,
          viewportID: 'product-gallery-onboarding-viewport',
        },
        {
          title: t('products-page.onboarding.steps.custom-view.title'),
          content: t('products-page.onboarding.steps.custom-view.description'),
          selector: '#product-gallery-custom-view',
          side: 'bottom',
          pointerPadding: 0,
          pointerRadius: 22,
          disableInteraction: true,
          scrollOffset: 24,
          viewportID: 'product-gallery-onboarding-viewport',
        },
        {
          title: t('products-page.onboarding.steps.view-toggle.title'),
          content: t('products-page.onboarding.steps.view-toggle.description'),
          selector: '#products-view-header__toggle',
          side: 'bottom',
          pointerPadding: 0,
          pointerRadius: 18,
          disableInteraction: true,
          scrollOffset: 24,
          viewportID: 'product-gallery-onboarding-viewport',
        },
        {
          title: t('products-page.onboarding.steps.countries.title'),
          content: t('products-page.onboarding.steps.countries.description'),
          selector: '#product-gallery-country-selector',
          pointerPadding: 0,
          pointerRadius: 24,
          disableInteraction: true,
          scrollOffset: 24,
          side: 'bottom-right',
          viewportID: 'product-gallery-onboarding-viewport',
        },
      ],
    },
  ]
}
